import { ChevronRight } from "@untitled-ui/icons-react";

type GroupSettingsRowProps = {
  label: string;
  value?: string;
  onClick?: () => void;
};

export default function GroupSettingsRow({
  label,
  value,
  onClick,
}: GroupSettingsRowProps) {
  const Component = onClick ? "button" : "div";

  return (
    <Component
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className="flex w-full items-center justify-between gap-2.5 border-b border-gray-100 px-6 py-4 text-start hover:bg-gray-50"
    >
      <span className="text-sm font-medium text-gray-900">{label}</span>
      <div className="text-primary-700 flex items-center gap-2">
        {value && <span className="text-sm font-medium">{value}</span>}
        {onClick && <ChevronRight className="size-5 shrink-0 rtl:rotate-180" />}
      </div>
    </Component>
  );
}
